<ion-content class="invoice">
    <ng-container>
        <app-header [isParentPage]="false" [title]="'Invoice'"></app-header>
        <ion-grid class="container-grid">
            <div class="loading-container" style="padding-top:15%" *ngIf="!loaded">
                <ion-spinner></ion-spinner>
            </div>
            <ion-row class="filter-row">
                <ion-grid>
                    <ion-row class="ion-align-items-center">

                        <ion-col size="12" size-md="3">
                        <ion-input
                            type="date"
                            [(ngModel)]="startDate"
                            class="color-light">
                        </ion-input>
                        
                        </ion-col>

                        <!-- End Date -->
                        <ion-col size="12" size-md="3">
                        <ion-input
                            type="date"
                            [(ngModel)]="endDate"
                            class="color-light">
                        </ion-input>
                        </ion-col>

                        <ion-col size="12" size-md="4">
                        <div class="cust-wrapper">
                            <span class="cust-label">Cust Code</span>
                            <ion-input
                            type="text"
                            [(ngModel)]="customerCode"
                            placeholder="Enter customer number"
                            class="color-light"
                            style="margin-left:10px;"
                            [disabled]="isCustomerCodeExist"
                            (keydown.enter)="onEnterKey($event)"
                            >
                            </ion-input>
                             <ion-button (click)="getInvoices()" color="gallaghergreen" class="btn-box-shadow"><span>Show</span></ion-button>
                        </div>
                        </ion-col>
                    </ion-row>
                    </ion-grid>


            </ion-row>
            <ion-row class="invoice-table-row" *ngIf="submitted">
                <div>
                    <ion-row>
                        <ion-header>Past Due Invoices</ion-header>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <app-invoice-table (paging)="setOverduePage($event)" [pageSize]="overduePageSize" [pageNumber]="overdueCurrPage" [rows]="overdueInvoices" [totalElements]="overdueTotalElements" [currentRoute]="currentRoute"></app-invoice-table>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-header class="invoice-header">Invoices from {{startDate | date: 'MM/dd/yyyy' ?? 'MM/dd/yyyy'}} to {{endDate | date: 'MM/dd/yyyy' ?? 'MM/dd/yyyy'}}</ion-header>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <app-invoice-table (paging)="setInvoicesPage($event)" [pageSize]="invoicePageSize" [pageNumber]="invoiceCurrPage" [rows]="invoices" [totalElements]="invoiceTotalElements" [currentRoute]="currentRoute"></app-invoice-table>
                        </ion-col>
                    </ion-row>
                </div>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>